import Product from '../components/Product';
import ProductItem from '../components/ProductItem';
import RTE from '../components/RTE';

export default class StaticProduct {
  constructor(section) {
    this.el = section.el;
    this.product = new Product({ el: this.el, data: section.data });
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }
  }

  onSectionUnload() {
    this.product.unload();
    this.products.forEach(product => product.unload());
    this.rtes.forEach(rte => rte.unload());
  }
}
